import { CONVERSION_EVENT } from 'modules/conversion/constants'
import getSubtotalCartSelector from 'modules/cart/redux/selectors/get-subtotal'
import logEventConversionUtil from 'modules/conversion/utils/log-event'
import logUtil from 'utils/log'

export default function logUserDataConversionEventAction () {
  return (dispatch, getState) => {
    const cartTotal = getSubtotalCartSelector()(getState())
    const properties = {
      event: CONVERSION_EVENT.USER_DATA,
      cart_total: cartTotal
    }

    logUtil('logUserDataConversionEventAction').debug('properties=', properties)
    logEventConversionUtil(CONVERSION_EVENT.USER_DATA, properties)
  }
}
